<div class="wheel--cr" [class.lose]="isLose()">
  <div class="wheel--cr__bet-button {{ color() }}" (click)="clickBet()">
    {{ wheelService.wheelMultipliers[color()] }}x
  </div>
  <div class="wheel--cr__summary">
    <div class="wheel--cr__summary-total {{ color() }}">
      <!-- {{ wheelService.betsList()[color()].length }} -->
      <number-flow style="color: currentColor" #bets></number-flow>
      Bets
    </div>
    <div class="wheel--cr__summary-value">
      <svg-icon
        class="currency-icon flex items-center justify-center s-16"
        src="assets/icons/core/price.svg"
        [style.--color]="color()"
      />
      <number-flow style="color: currentColor" #total></number-flow>
    </div>
  </div>
  <div class="divider horizontal w-full"></div>
  <div
    class="wheel--cr__bets"
    [@listAnimation]="wheelService.betsList()[color()].length"
  >
    @for (bet of wheelService.betsList()[color()]; track $index) {
    <div
      class="wheel--cr__bet"
      (click)="contextMenuService.open($event,  {
      user: bet,
    })"
    >
      <img class="wheel--cr__bet-avatar" [src]="bet.avatar" />
      <span class="wheel--cr__bet-name">
        {{ bet.name }}
      </span>
      <div class="wheel--cr__bet-value">
        <app-cost
          [cost]="bet.amount"
          [balanceType]="bet.balancetype ?? bet.baltype"
        ></app-cost>
      </div>
    </div>
    }
  </div>
</div>
<div class="wheel--total-won" [class.lose]="isLose()" [class.won]="isWon()" #totalWonContainer>
  {{ isWon() ? 'Total paid' : 'Loss' }}
  <svg-icon
    class="flex items-center justify-center s-16"
    src="assets/icons/core/price.svg"
  />
  <number-flow style="color: currentColor" #totalWon></number-flow>
</div>
